import { get } from 'lodash';
import { useFind } from 'api/APIHooks';

/**
 * Fetches the lineage for a given original service authorization ID.
 * @param {string} originalId - The ID of the original service authorization
 * @param {Object} options - { enabled }
 * @returns {Object} { lineageAuthorizations, isSuccess, isLoading, error }
 */
const useServiceAuthorizationLineage = (originalId, { enabled = true } = {}) => {
  const {
    data, isLoading, isSuccess, error,
  } = useFind(
    'service_authorization',
    { original_service_authorization: originalId },
    {
      queryConfig: {
        enabled: !!originalId && enabled,
        placeholderData: undefined,
      },
    },
  );

  const lineageAuthorizations = get(data, 'data.data', [])
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

  return {
    lineageAuthorizations,
    isSuccess,
    isLoading,
    error,
  };
};

export default useServiceAuthorizationLineage;
